import React from "react";
import Challege from "../components/challenge/challenge";

export default function ChallengeRouter() {
  return <Challege />;
}
